import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import DialogRubro from "../../components/Rubro/dialogRubro";
import * as rubrosActions from "../../reducers/rubrosReducer/actions";
import { rubrosDataSelector } from "../../selectors/rubrosSelector";
import { catalogoDataSelector } from "../../selectors/catalogoSelector";

class DialogRubroContainer extends React.Component {
  constructor(props) {
    super(props);

    this.props.sagaGetRubros(null, true, true);

    this.state = {
      selectedIndexRubro: 0,
    };
  }

  handleChangeRubro = (e) => {
    let state = { ...this.state };
    state.selectedIndexRubro = e.target.value;
    this.setState({
      selectedIndexRubro: state.selectedIndexRubro,
    });
  };

  render() {
    return (
      <div>
        <DialogRubro
          rubros={this.props.data.rubros}
          handleCancelButton={this.props.handleCancelButton}
          selectedIndexRubro={this.state.selectedIndexRubro}
          handleChangeRubro={this.handleChangeRubro}
          payloadCatalogo={this.props.payloadCatalogo}
          payloadRubro={this.state.selectedIndexRubro}
          idCatalogo={this.props.idCatalogo}
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...rubrosActions,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    data: rubrosDataSelector(state),
    dataCatalogo: catalogoDataSelector(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DialogRubroContainer);
